/* eslint-disable @typescript-eslint/no-explicit-any */
import Notify from 'quasar/src/plugins/Notify.js';;
import { NOTIFY_OPTIONS } from '@/common/constants/notityOptions';

/**
 * Function that receive a message and show
 * a quasar notify with positive color and the message.
 * @param type => Notify type
 * @param message => Notify message
 * @param timeout => Notify duration
 */
export function showNotify(type: 'positive' | 'negative', message: string, actions?: any[], timeout = 1000): void {
  Notify.create({
    ...NOTIFY_OPTIONS[type],
    message,
    actions,
    timeout,
  });
}

export default showNotify;
